import { create } from "zustand"
import { subscribeWithSelector } from "zustand/middleware"

export default create(subscribeWithSelector((set) =>
{
    return {
        // View state machine
        // 'default_state' => orbit freely, only SEC markers interactable
        // 'sec_zoomed'    => camera at SEC POS/TAR, filtered POIs visible
        viewState: 'default_state',

        // POI (Points of Interest) System
        // Control POI visibility explicitly
        poiVisible: false,
        
        // SEC (Section) System
        selectedSec: null,

        // POI popup & selection state (for UI layer)
        openPoiIndex: null,
        selectedPoiData: null,
        
        // Weapons Bay Animation States
        weaponsBayOpen: false,
        weaponsBayAnimating: false,
        
        // PJDAM Fire Animation State (for Jet VFX visibility)
        pjdamFireActive: false,

        // Default camera position/target (editable)
        // Stored as arrays [x, y, z] for easy serialization
        defaultCameraPos: [165, 78, -111],
        defaultCameraTar: [0, 0, 0],
        
        // Cinematic camera position (200 units behind default position)
        cinematicCameraPos: [265, 30, -300],
        cinematicCameraTar: [50, -100, 0],
        
        // Cinematic mode state
        cinematicMode: false,

        // Whether the RELEASE WEAPON button has completed its initial fade-in
        releaseWeaponFaded: false,

        // Float animation intensity (reduced when zoomed into SEC)
        floatIntensityMultiplier: 1.0,

        // Device detection state
        deviceType: 'desktop', // 'desktop' | 'tablet' | 'phone'
        deviceOrientation: 'landscape', // 'landscape' | 'portrait'

        setPoiVisible: (visible) =>
            {
                set(() => ({ poiVisible: visible }))
            },

        setWeaponsBayOpen: (isOpen) =>
            {
                set(() => ({ weaponsBayOpen: isOpen }))
            },

        setWeaponsBayAnimating: (isAnimating) =>
            {
                set(() => ({ weaponsBayAnimating: isAnimating }))
            },

        setPjdamFireActive: (active) =>
            {
                set(() => ({ pjdamFireActive: active }))
            },

        // Enter SEC zoomed state with identifiers for POS/TAR
        enterSecZoom: ({ secId }) =>
            {
                set(() => ({
                    viewState: 'sec_zoomed',
                    selectedSec: secId,
                    poiVisible: true
                }))
            },

        // Exit back to default: clear selection, hide POIs
        exitToDefault: () =>
            {
                set(() => ({
                    viewState: 'default_state',
                    selectedSec: null,
                    poiVisible: false,
                    openPoiIndex: null,
                    selectedPoiData: null
                }))
            },

        // POI popup setters
        setOpenPoiIndex: (idx) => {
            set(() => ({ openPoiIndex: idx }))
        },
        setSelectedPoiData: (data) => {
            set(() => ({ selectedPoiData: data }))
        },
        
        // Float intensity controller
        setFloatIntensityMultiplier: (value) => {
            set(() => ({ floatIntensityMultiplier: value }))
        },
        
        // Device type setters
        setDeviceType: (type) => {
            set(() => ({ deviceType: type }))
        },
        setDeviceOrientation: (orientation) => {
            set(() => ({ deviceOrientation: orientation }))
        },
        
        // Cinematic mode setter
        setCinematicMode: (value) => {
            set(() => ({ cinematicMode: value }))
        },

        // Release weapon fade-in setter
        setReleaseWeaponFaded: (value) => {
            set(() => ({ releaseWeaponFaded: value }))
        },

        // Model ready state — set true once the F35 GLB is decrypted and rendered
        modelReady: false,
        setModelReady: (value) => {
            set(() => ({ modelReady: value }))
        },
        }
}))
